// extracted by mini-css-extract-plugin
export default {"container":"ELDj9z w9sViO mz-default-dark-font","nav":"UwVDZn mz-mob-screen__nav","nav__title":"IujnPu","nav__button":"WXP_vu","nav__backIcon":"GiWyAc","content":"mkQrlF"};